<script setup lang="ts">
import '@stoplight/elements/styles.min.css';
import '@stoplight/elements/web-components.min.js';
</script>

<template>
	<main class="h-dvh overflow-auto">
		<slot />
	</main>
</template>
